export default __webpack_public_path__ + "static/media/beach.806850ec.png";